<template>
  <div style="display: inline-block">
    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-container v-on="on" class="separator d-flex justify-space-between">
          <span class="pa-1 ml-2 ml-md-0 pa-md-2 separator-percent">{{text}}</span>
          <span class="pt-1 pa-md-2 pr-3 separator-info">
            <v-icon color="#3300cc" size="19">mdi-information-outline</v-icon>
          </span>
        </v-container>
      </template>
      <span>{{tooltip}}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '0%'
    },
    tooltip: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>
.separator {
  background-color: white;
  border: 1px solid white;
  color: #3300cc;
  padding: 0;
  font-weight: bold;
  font-size: 15px;
}

.separator-info {
  padding-right: 7px !important;
}
</style>